import { MANAGED_EVENT_TYPE } from 'constants/event_types'

export const hasLockingRule = (lockingRules, lockingRuleName) => lockingRules.some(({ name }) => name === lockingRuleName)

export const isEtLocked = (eventType, lockingRuleName) => {
  const lockingRules = eventType?.event_type_lock?.locking_rules || []
  const isManaged = eventType.type === MANAGED_EVENT_TYPE

  if (!isManaged && !eventType.parent_id) { return false }

  return hasLockingRule(lockingRules, lockingRuleName)
}

export const isAnyLocksEnabled = (eventType, locks) => locks.some((lock) => isEtLocked(eventType, lock))
